// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#ui-dashboards #ui-user-platform #main-app,#ui-dashboards #ui-user-platform #main-app .vue-dashboard-host,#ui-dashboards #ui-user-platform #main-app main{height:100%;width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
